import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'

const RolesGestionApp = lazy(() => import('./view/RolesGestion'))
const RolesRegistroApp = lazy(() => import('./view/registro/RolesRegistro'))
const RolesActualizarApp = lazy(() => import('./view/actualizar/RolesActualizar'))

export const rolesV2RoutesMap = {
  gestion: {
    path: '/rolesV2/gestion',
    name: 'Gestión de roles V (dos)',
  },
  nuevo: {
    path: '/rolesV2/nuevo',
    name: 'Nuevo Rol',
  },
  modificar: {
    path: '/rolesV2/modificar',
    name: 'Modificar Rol',
  },
}

const rolesV2Routes = [
  {
    path: rolesV2RoutesMap.gestion.path,
    element: <RolesGestionApp />,
    auth: authRoles.admin,
  },
  {
    path: rolesV2RoutesMap.nuevo.path,
    element: <RolesRegistroApp />,
    auth: authRoles.admin,
  },
  {
    path: `${rolesV2RoutesMap.modificar.path}/:id`,
    element: <RolesActualizarApp />,
    auth: authRoles.admin,
  },
]
export default rolesV2Routes
